<template>
  <div class="card shadow">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-6">
          Newsletters
        </div>
        <div class="col-6">
          <newsletter-create v-if="$store.getters.isAdmin" />
        </div>
      </div>
    </div>
    <div v-loading="loading">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th>Subject</th>
            <th>Scheduled</th>
            <th v-if="$store.getters.isAdmin">Operations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="newsletter in newsletters" :key="newsletter.id">
            <td><router-link :to="{ name: 'newsletters-id', params: { id: newsletter.id } }">{{ newsletter.title }}</router-link></td>
            <td>{{ newsletter.publishedAt }}</td>
            <td v-if="$store.getters.isAdmin">
              <newsletter-test
                v-if="!newsletter.sent"
                :newsletterId="newsletter.id"
                @update="getNewsletters"
              />
              <newsletter-publish
                v-if="!newsletter.sent && newsletter.tested"
                :newsletterId="newsletter.id"
                :publishedAt="getTimestamp(newsletter.publishedAt)"
                @update="getNewsletters"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NewsletterCreate from '@/components/Newsletter/NewsletterCreate'
import NewsletterTest from '@/components/Newsletter/NewsletterTest'
import NewsletterPublish from '@/components/Newsletter/NewsletterPublish'

export default {
  data() {
    return {
      loading: true,
      newsletters: [],
    }
  },

  components: {
    NewsletterCreate,
    NewsletterTest,
    NewsletterPublish,
  },

  async mounted() {
    await this.getNewsletters()
  },

  methods: {
    getTimestamp(timestamp) {
      return timestamp ? new Date(timestamp) : null
    },
    async getNewsletters() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/newsletters`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.newsletters = data.newsletters.map(item => {
        item.publishedAt = moment(item.publishedAt).fromNow()
        return item
      })
    },
  },
}
</script>
